$ const themes = ["kiwi", "pink", "lilac", "orange"];

<li
  class=[
    "storefronts__storefront",
    `storefronts__storefront--${themes[input.index % 4]}`,
  ]
  key="storefront-card"
  onMouseenter("measureStorefrontCard")
>
  <a href=input.storefrontUrl class="storefronts__storefront-link">
    <div class="storefronts__storefront-image">
      <if(input.profileImage.length)>
        <img
          src=input.profileImage
          alt=`${input.firstName} ${input.lastName}`
          class="storefronts__storefront-img"
          loading="lazy"
        >
      </if>
      <else>
        <div class=[
          "storefronts__storefront-image-placeholder",
          `index-${input.index % 5}`,
        ]>
          ${input.firstName.charAt(0)}${input.lastName?.charAt(0) ?? ""}
        </div>
      </else>
    </div>
    <div class="storefronts__storefront-content">
      <span class="storefronts__storefront-name">
        ${input.firstName} ${input.lastName}
      </span>
      <span class="storefronts__storefront-description">
        ${input.description}
      </span>
    </div>
    <div class="storefronts__storefront-cta">
      <ebay-icon-button tabindex="-1">
        <ebay-chevron-right-16-icon/>
      </ebay-icon-button>
    </div>
  </a>

  <if(input.productCards)>
    <div class=[
      "storefronts__storefront-products",
      `storefronts__storefront-products--${state.displayPosition}`,
    ]>
      <for|productCard| of=input.productCards>
        <div class=[
          "storefronts__storefront-product",
          productCard.image && "storefronts__storefront-product--no-scrim",
        ]>
          <img
            src=component.getProductCardImgSrc(productCard)
            class="storefronts__storefront-product-image"
            loading="lazy"
          >
        </div>
      </for>
    </div>
  </if>
</li>
